import { useContext, useState } from 'react';
import styles from './SearchBar.module.scss';
import SearchBarSpecialtySelect from './search-bar-specialty-select/SearchBarSpecialtySelect';
import SearchBarCriteriaInput from './search-bar-criteria-input/SearchBarCriteriaInput';
import SearchBarLocationInput from './search-bar-location-input/SearchBarLocationInput';
import SearchKeyWordInput from './search-bar-key-word-input/SearchBarKeyWordInput';
import SearchBarPhoneInput from './search-bar-phone-input/SearchBarPhoneInput';
import SearchBarDistanceSelect from './search-bar-distance-select/SearchBarDistanceSelect';
import SearchBarButton from './search-bar-button/SearchBarButton';
import { AppContext } from '../../context/AppContext';
import { DirectoryListType } from '../directory-list/DirectoryList';
import CustomAlert from '../alerts';
import TransportationSearch from '../transportation/TransportationSearch';
import HearingAidSearch from '../hearing-aid/HearingAidSearch';

const SearchBar = () => {
  const appContext = useContext(AppContext);
  const { isDisabled } = useContext(AppContext);
  const [showAlert] = useState(false);
  const [severityAlert] = useState<'error' | 'info' | 'success' | 'warning'>('error');
  const messageAlert = 'Please set a ZIP Code in a correct format, example: 12345.';

  return (
    <>

      {(() => {
        switch (appContext.directoryListType) {

          case DirectoryListType.all:
            return <div className={styles.keywordSearchBar}>
              <SearchKeyWordInput />
              <SearchBarButton />
            </div>;
          case DirectoryListType.phone:
            return <div className={styles.keywordSearchBar}>
              <SearchBarPhoneInput />
              <SearchBarButton />
            </div>;
          case DirectoryListType.hearingAid:
            return <div>
              <HearingAidSearch />
            </div>;
          case DirectoryListType.transportation:
            return <div>
              <TransportationSearch />
            </div>;
          default:
            return <div className={styles.searchBar}>
              <SearchBarSpecialtySelect />
              <SearchBarCriteriaInput />
              <SearchBarLocationInput />
              <SearchBarDistanceSelect />
              <SearchBarButton />
            </div>;


        }
      })()}
      {/* {appContext.directoryListType !== DirectoryListType.all ? (
        <div className={styles.searchBar}>
          <SearchBarSpecialtySelect />
          <SearchBarCriteriaInput />
          <SearchBarLocationInput />
          <SearchBarDistanceSelect />
          <SearchBarButton />
        </div>
      ) : null}
      {appContext.directoryListType === DirectoryListType.hearingAid ? (
        <div>
          <HearingAidSearch />
        </div>
      ) : null}
      {appContext.directoryListType === DirectoryListType.transportation ? (
        <div>
          <TransportationSearch />
        </div>
      ) : null}
      {appContext.directoryListType === DirectoryListType.all ? (
        <div className={styles.keywordSearchBar}>
          <SearchKeyWordInput />
          <SearchBarButton />
        </div>
      ) : null} */}
      {(showAlert || isDisabled) && <CustomAlert severity={severityAlert} message={messageAlert} />}
    </>
  );
};

export default SearchBar;
